import PropTypes from 'prop-types';

export default function OutlineSearch(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M8.387 14.2c2.975 0 5.387-2.507 5.387-5.6 0-3.093-2.412-5.6-5.387-5.6C5.412 3 3 5.507 3 8.6c0 3.093 2.412 5.6 5.387 5.6ZM16.006 16.56 12.39 12.8"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineSearch.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
